import { ThunkAction } from 'redux-thunk';

import RootState from 'Store/Root';

import {
  initializeImageMagick,
} from '@imagemagick/magick-wasm';

export const LOADING_IMAGEMAGICK = 'LOADING_IMAGEMAGICK';
export const LOADED_IMAGEMAGICK = 'LOADED_IMAGEMAGICK';
export const LOAD_IMAGEMAGICK_FAILED = 'LOADED_CATEGORIES_IMAGEMAGICK';

export interface ImageMagickAction {
  type: string;
}

function loadingImageMagick(): ImageMagickAction {
  return {
    type: LOADING_IMAGEMAGICK
  };
}

function imageMagickLoadFailed(): ImageMagickAction {
  return {
    type: LOAD_IMAGEMAGICK_FAILED
  };
}

function imageMagickLoaded(): ImageMagickAction {
  return {
    type: LOADED_IMAGEMAGICK
  };
}

export function loadImageMagick(): ThunkAction<Promise<any>, RootState, any> {
  return (dispatch, getState) => {
    const state = getState();

    if (state.imageMagick.loaded || state.imageMagick.loading) {
      return Promise.resolve(true);
    }

    dispatch(loadingImageMagick());

    const wasmLocation = new URL('@imagemagick/magick-wasm/magick.wasm', import.meta.url);
    return initializeImageMagick(wasmLocation)
      .then(
        c => dispatch(imageMagickLoaded()),
        e => dispatch(imageMagickLoadFailed())
      );
  };
}
